import { IMarqueeItem, IStackGroup } from '../interfaces/interfaces';

export const stackGroups: IStackGroup[] = [
    {
        title: 'Agents & orchestration',
        items: ['LangGraph', 'LangChain', 'Amazon Bedrock', 'ReAct', 'MCP', 'SSE streaming', 'SQS / SNS'],
    },
    {
        title: 'RAG & search',
        items: ['S3 Vectors', 'Hybrid search', 'AST code chunking', 'Incremental embeddings', 'Ingestion pipelines'],
    },
    {
        title: 'LLM platform',
        items: ['LiteLLM gateway', 'Multi-provider routing', 'Prompt caching', 'Spend tracking', 'Langfuse'],
    },
    {
        title: 'Evals & quality',
        items: ['promptfoo', 'LLM-as-judge', 'Guardrails', 'Playwright E2E'],
    },
    {
        title: 'Languages',
        items: ['Python', 'TypeScript', 'JavaScript', 'SQL', 'Java'],
    },
    {
        title: 'Back-end',
        items: ['FastAPI', 'Fastify', 'Node.js', 'Express', 'REST APIs'],
    },
    {
        title: 'Data',
        items: ['PostgreSQL', 'MongoDB', 'Redis'],
    },
    {
        title: 'Front-end',
        items: ['React', 'MobX', 'Redux', 'SCSS', 'HTML5'],
    },
    {
        title: 'Infrastructure & CI/CD',
        items: ['Terraform', 'AWS', 'ECS Fargate', 'EKS', 'CloudFront', 'WAF', 'GitHub Actions', 'Docker', 'Jenkins'],
    },
];

/** The scrolling ticker under the hero. Colour is the brand hue. */
export const marqueeTech: IMarqueeItem[] = [
    { label: 'Python', color: '#ffd43b' },
    { label: 'LangGraph', color: '#3ddc97' },
    { label: 'Amazon Bedrock', color: '#ff9900' },
    { label: 'LiteLLM', color: '#6e8bff' },
    { label: 'MCP', color: '#d97757' },
    { label: 'RAG', color: '#9db2ff' },
    { label: 'S3 Vectors', color: '#a78bfa' },
    { label: 'Langfuse', color: '#f59e0b' },
    { label: 'promptfoo', color: '#ef4444' },
    { label: 'TypeScript', color: '#3178c6' },
    { label: 'FastAPI', color: '#05998b' },
    { label: 'React', color: '#61dafb' },
    { label: 'PostgreSQL', color: '#4169e1' },
    { label: 'Redis', color: '#ff4438' },
    { label: 'Terraform', color: '#7b42bc' },
    { label: 'AWS', color: '#ff9900' },
];
